import React from 'react';

import Group from '@pb/kit-component-group';
import {Cell, Row} from '@pb/kit-component-table';

import {trackingTableNoResultsCaption} from './no-results-row.module.styl';

const NO_RESULTS_MESSAGE = 'No results found. Please check spelling or try another term.';

type Props = {
    colSpan: number,
    message?: string,
};

export const NoResultsRow = ({colSpan, message}: Props) => {
    return (
        <Row>
            <Cell colSpan={colSpan}>
                <Group justify="center">
                    <span className={trackingTableNoResultsCaption}>
                        {message || NO_RESULTS_MESSAGE}
                    </span>
                </Group>
            </Cell>
        </Row>
    );
};
